import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import PagePayments from '@pages/payments/ui/PagePayments';

export const Route = createFileRoute('/_auth/_layout/payments')({
  component: PagePayments,
});
